import styled from 'styled-components';
import AddButton from 'shared/ui/AddButton';

const Button = styled(AddButton)`
  margin-right: auto;
`;
Button.displayName = 'Button';

export default Button;
